/*
 * Copyright (C) 2022 Pitagon., JSC. - All Rights Reserved.
 *
 * Unauthorized copying or redistribution of this file in source and binary forms via any medium
 * is strictly prohibited.
 */

import {DOCUMENT} from '@angular/common';
import {Component, Inject, Input, OnDestroy} from '@angular/core';

@Component({
  selector: 'ngx-pids-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  host: {
    class: 'ngx-pids-sidebar'
  }
})
export class SidebarComponent implements OnDestroy {

  @Input() position: 'left' | 'right' = 'left';
  // @ts-ignore
  @Input() invisibleBackdrop: boolean;

  constructor(@Inject(DOCUMENT) private document: Document) {
  }

  // @ts-ignore
  private _opened: boolean;

  get opened() {
    // @ts-ignore
    return this._opened;
  }

  @Input() set opened(opened: boolean) {
    this._opened = opened;
    opened ? this.enableScrollblock() : this.disableScrollblock();
  }

  get positionLeft() {
    return this.position === 'left';
  }

  get positionRight() {
    return this.position === 'right';
  }

  enableScrollblock() {
    if (!this.document.body.classList.contains('ngx-pids-scrollblock')) {
      this.document.body.classList.add('ngx-pids-scrollblock');
    }
  }

  disableScrollblock() {
    if (this.document.body.classList.contains('ngx-pids-scrollblock')) {
      this.document.body.classList.remove('ngx-pids-scrollblock');
    }
  }

  open() {
    this.opened = true;
  }

  close() {
    this.opened = false;
  }

  ngOnDestroy(): void {
  }
}
